import { FC, PropsWithChildren } from "react";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { useResponsiveContext } from "@context/ResponsiveContext";
import WithTouchRipple from "../WithTouchRipple";

const ActionButton: FC<
  PropsWithChildren<{
    label: string;
    onClick: () => void;
    disabled?: boolean;
  }>
> = ({ label, children, onClick, disabled = false }) => {
  const { palette } = useTheme();
  const { onMobile } = useResponsiveContext();

  return (
    <Box
      onClick={() => !disabled && onClick()}
      flex={"1 1 0px"}
      minWidth={0}
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
      flexDirection={"column"}
      color={disabled ? palette.text.disabled : palette.text.primary}
    >
      <IconButton size={onMobile ? "small" : "medium"} disabled={disabled}>
        {children}
      </IconButton>
      <Typography
        variant={"caption"}
        textAlign={"center"}
        maxWidth={"100%"}
        whiteSpace={"nowrap"}
        overflow={"hidden"}
        textOverflow={"ellipsis"}
        color={disabled ? palette.text.disabled : palette.text.primary}
      >
        {label}
      </Typography>
    </Box>
  );
};

export const ActionButtonWithRipple = WithTouchRipple(ActionButton);

export default ActionButton;
